export default function Returns(){return <div><h1 className="text-2xl font-black">Returns</h1><p className="mt-2 text-slate-600">After-sales requests and refunds.</p></div>;}
